// https://digital.vfc.com/wiki/display/ECOM15/Loyalty+Contents
import type { SupportedBrand } from '#types/env'
import { brand } from '#root/env/common'

type LoyaltyTile = {
  id: number | string
  internal_name?: string
  heading?: string
  metric_amount?: string
  name?: string
  points?: number
  subject?: string
  extra_json?: any
}

const loyaltyProgramNames: Partial<Record<SupportedBrand, string>> = {
  thenorthface: 'XPLR Pass',
  timberland: 'Community',
  vans: 'Vans Family'
}

export const getLoyaltyProgramName = (activeBrand: SupportedBrand, fallback = 'Loyalty') =>
  loyaltyProgramNames[activeBrand] || fallback

const getTileCustomVariables = (tile: LoyaltyTile) => ({
  loyaltyTileID: tile.id,
  loyaltyTileInternalName: tile.internal_name || tile.id,
  loyaltyTileAction: tile.extra_json?.action || 'no_action',
  loyaltyTileType: tile.extra_json?.type || '',
  loyaltyTilePoints: tile.metric_amount ?? tile.points ?? ''
})

const getTileEvent = (
  eventAction: 'Tile Open' | 'Tile Conversion' | 'Tile Close',
  customMetrics: Partial<Record<'elementView' | 'elementConversion' | 'elementClose', number>>,
  tile: LoyaltyTile
) => ({
  event: 'loadEventData',
  eventCategory: getLoyaltyProgramName(brand),
  eventAction,
  eventLabel: tile.internal_name || tile.id,
  nonInteractive: false,
  customMetrics,
  customVariables: getTileCustomVariables(tile),
  _clear: true
})

export default {
  onInfoClick: (eventLabel: 'Meter Explanation' | 'Credit Explanation') => ({
    event: 'loadEventData',
    eventCategory: 'Loyalty',
    eventAction: 'Info Click',
    eventLabel,
    nonInteractive: true,
    customMetrics: {},
    customVariables: {},
    _clear: true
  }),
  onMembershipCardClick: () => ({
    event: 'loadEventData',
    eventCategory: 'Loyalty',
    eventAction: 'Membership Card Click',
    eventLabel: undefined,
    nonInteractive: true,
    customMetrics: {},
    customVariables: {},
    _clear: true
  }),
  onDownloadAppClick: () => ({
    event: 'loadEventData',
    eventCategory: 'Loyalty',
    eventAction: 'Download App Click',
    eventLabel: undefined,
    nonInteractive: true,
    customMetrics: {},
    customVariables: {},
    _clear: true
  }),
  onSmsSignUpSubmit: () => ({
    event: 'loadEventData',
    eventCategory: 'Loyalty',
    eventAction: 'SMS Sign Up',
    eventLabel: 'Submit',
    nonInteractive: true,
    customMetrics: {},
    customVariables: {},
    _clear: true
  }),
  onSmsSignUpConfirmed: () => ({
    event: 'loadEventData',
    eventCategory: 'Loyalty',
    eventAction: 'SMS Sign Up',
    eventLabel: 'Confirmed',
    nonInteractive: true,
    customMetrics: {},
    customVariables: {},
    _clear: true
  }),
  onTileOpen: (tile: LoyaltyTile) => getTileEvent('Tile Open', { elementView: 1 }, tile),
  onTileConversion: (tile: LoyaltyTile) => getTileEvent('Tile Conversion', { elementConversion: 1 }, tile),
  onTileClose: (tile: LoyaltyTile) => getTileEvent('Tile Close', { elementClose: 1 }, tile)
}
